export const NOW_LABEL = 'NOW!'
